const REGEX_PT = /^351[0-9]{9}$/
const REGEX_ES = /^[0-9]{9,}$/

export class ResforPhone {
  private _phoneNumber: string

  constructor (phoneNumber: string) {
    if (REGEX_ES.test(phoneNumber) === false && REGEX_PT.test(phoneNumber) === false) {
      throw new TypeError('Phone format wrong')
    }
    this._phoneNumber = phoneNumber
  }

  phoneNumber (): string {
    return this._phoneNumber
  }
}
